import { API_URL } from "./config.js";
document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("login-form");
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    try {
      const res = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const result = await res.json();
      if (res.ok) {
        localStorage.setItem("token", result.token);
        window.location.href = "/";
      } else {
        window.showSnackbar(result.error || "Error de autenticación", "error");
      }
    } catch (err) {
      window.showSnackbar("Error de red o del servidor", "error");
    }
  });
});
